import { loadLastStamp } from "../warning/actions";
import { makePrivateApiCall } from "utilities/dist/api";
import { trackSaveStampAssignmentEvent } from "../../common/analytics";
import { loadStampRoll } from "../roll/actions";

export const assignStamps =
    (assignment = {}) =>
    dispatch => {
        trackSaveStampAssignmentEvent();
        const request = {
            url: `/stamp/roll/${assignment.roll_id}/assign`,
            method: "put",
            data: assignment,
        };

        return makePrivateApiCall(request).then(res => {
            if (res.data) {
                if (res.data?.length) {
                    dispatch(loadLastStamp());
                    dispatch(loadStampRoll());
                }
                return res.data;
            }

            return null;
        });
    };

export const loadDestroyedStamps = () => {
    return makePrivateApiCall({
        url: "/stamp/destroyed",
        method: "GET",
    }).then(res => res.data);
};

export const undoDestroyedStamps =
    (selectedIds = []) =>
    async dispatch => {
        if (!selectedIds?.length) return Promise.resolve([]);
        return makePrivateApiCall({
            url: `/stamp/undo-destroy?ids=${selectedIds.join()}`,
            method: "DELETE",
        }).then(res => {
            if (res.data.success) {
                dispatch(loadLastStamp());
                dispatch(loadStampRoll());
            }

            return res.data;
        });
    };
